import ReactModal from "react-modal";
import './index.css';

export default function ModalError({state, setState, stateName, custom, error}){
    return (
        <ReactModal
            isOpen={state}
            onRequestClose={() => setState((prevState) => ({...prevState, [stateName]: false}))}
            overlayClassName="modal-overlay"
            className="modal-error"
            style={custom}
        >
            <div className="modal__header">
                <h2 className="modal___title">Erro</h2>
                <button className="modal___button" onClick={() => setState((prevState) => ({...prevState, [stateName]: false}))}>Fechar</button>
            </div>
            <div className="modal__body">
                <p className="modal___error">{error}</p>
            </div>
        </ReactModal>
    )
}